import { render, staticRenderFns } from "./DeskDiseaseEdit.vue?vue&type=template&id=35b2cb5d&"
import script from "./DeskDiseaseEdit.vue?vue&type=script&lang=js&"
export * from "./DeskDiseaseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35b2cb5d')) {
      api.createRecord('35b2cb5d', component.options)
    } else {
      api.reload('35b2cb5d', component.options)
    }
    module.hot.accept("./DeskDiseaseEdit.vue?vue&type=template&id=35b2cb5d&", function () {
      api.rerender('35b2cb5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/deskinfo/deskinfo-manage/components/DeskDiseaseEdit.vue"
export default component.exports